import axios from "axios";

// Use this project's backend (mirrors the mobile-app schema).
export const ASTRO_API =
  (process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "") + "/api";

export const api = axios.create({
  baseURL: ASTRO_API,
  headers: { "Content-Type": "application/json" },
});

export const adminApi = (pin) =>
  axios.create({
    baseURL: ASTRO_API,
    headers: {
      "Content-Type": "application/json",
      "X-Admin-Pin": pin,
    },
  });

// Constants
export const ASSET_ICON =
  "https://customer-assets.emergentagent.com/job_jyotish-bilingual/artifacts/rmr7qbfy_astrodev-app-icon-512.png";
